import { firestore } from "../firebase/firestore"

export const getEnviroments = () => {
    return firestore.collection('config_public').doc('enviroments').get()
};
